import { render, staticRenderFns } from "./FrzTypeObservation.vue?vue&type=template&id=2e87f64f"
import script from "./FrzTypeObservation.vue?vue&type=script&lang=js"
export * from "./FrzTypeObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports